import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isAuth } from '../../redux/selector/User';
import {
  getShortlistInitialized,
  getShortlistLoading,
  isPlayerShortlisted,
} from '../../redux/selector/Shortlist';
import {
  ensureShortlist,
  toggleShortlistPlayer,
} from '../../redux/actions/Shortlist';
import { StyledStarButton } from './styled';

export default function ShortlistToggle({ playerId, size = 18 }) {
  const dispatch = useDispatch();
  const authenticated = useSelector(isAuth);
  const initialized = useSelector(getShortlistInitialized);
  const loading = useSelector(getShortlistLoading);
  const listed = useSelector(isPlayerShortlisted(playerId));
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (authenticated && !initialized && !loading) {
      dispatch(ensureShortlist());
    }
  }, [authenticated, dispatch, initialized, loading]);

  if (!authenticated || !playerId) return null;

  const toggle = async (event) => {
    event.stopPropagation();
    setBusy(true);
    try {
      await dispatch(toggleShortlistPlayer(playerId));
    } finally {
      setBusy(false);
    }
  };

  return (
    <StyledStarButton
      type="button"
      disabled={busy || loading}
      $active={listed}
      aria-pressed={listed}
      aria-label={listed ? 'Remove from shortlist' : 'Add to shortlist'}
      title={listed ? 'Remove from shortlist' : 'Add to shortlist'}
      onClick={toggle}
    >
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill={listed ? 'currentColor' : 'none'}
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden
      >
        <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
      </svg>
    </StyledStarButton>
  );
}
